import { CartItem } from '@/models/cart/cart-item'

/**
 * カート画面で当日発送のカウントダウンを出すときの注文締切。
 *
 * 購入対象の商品が 1 件以上あり、その全てが当日発送可能なときだけ締切を返す。
 * 1 件でも不明な商品があれば null（当日発送を約束できない注文になるため、煽らない）。
 *
 * @param purchasableItems 購入可能な商品のみを与えること。購入不可の商品が含まれていた場合の挙動は保証しない
 */
export function orderDeadlineForSameDayShipping(purchasableItems: ReadonlyArray<CartItem>): Date | null {
  if (purchasableItems.length === 0) {
    return null
  }

  const deadlines: Date[] = []
  for (const item of purchasableItems) {
    if (item.sameDayShipping.status !== 'available') {
      return null
    }
    deadlines.push(item.sameDayShipping.orderDeadlineAt)
  }

  // 締切は SKU ごとの条件で、一致を前提にしない。複数あるときは最も厳しい（早い）締切を表示する
  return deadlines.reduce((earliest, deadline) => (deadline < earliest ? deadline : earliest))
}

export interface RemainingTime {
  readonly hours: number
  readonly minutes: number
  readonly seconds: number
}

const MILLISECONDS_PER_SECOND = 1000
const SECONDS_PER_MINUTE = 60
const SECONDS_PER_HOUR = 3600

/**
 * 締切までの残り時間。
 *
 * 秒未満は切り上げる。切り捨てると締切の 1 秒前から「0 秒」と表示され、まだ注文できるのに締切を過ぎたように見えるため。
 */
export function remainingUntil(deadline: Date, now: Date): RemainingTime | null {
  const totalSeconds = Math.ceil((deadline.getTime() - now.getTime()) / MILLISECONDS_PER_SECOND)
  if (totalSeconds <= 0) {
    return null
  }

  return {
    hours: Math.floor(totalSeconds / SECONDS_PER_HOUR),
    minutes: Math.floor((totalSeconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE),
    seconds: totalSeconds % SECONDS_PER_MINUTE,
  }
}
